import React, { Component } from 'react';
import styled from 'styled-components';
import { Link, Redirect } from 'react-router-dom';

// Custom components
import CompanyPageTitle from 'containers/CompanyContainer/CompanyPageTitle';
import FormImageInput from 'containers/CompanyContainer/Forms/Components/FormImageInput';
import FormTextField from 'containers/CompanyContainer/Forms/Components/FormTextField';
import FormTextArea from 'containers/CompanyContainer/Forms/Components/FormTextArea';
import FormSelectField from 'containers/CompanyContainer/Forms/Components/FormSelectField';
import FormCheckboxField from 'containers/CompanyContainer/Forms/Components/FormCheckboxField';
import FormSectionTitle from 'containers/CompanyContainer/Forms/Components/FormSectionTitle';
import LoaderWrapper from 'containers/CompanyContainer/LoaderWrapper';

import Button from 'components/Primatives/Button';
import H2 from 'components/Primatives/H2';

// Constants
import { constants } from 'constants/index';

export const ComponentWrapper = styled.div`
    background: ${constants.color.grey5};
    height: 100vh;
    width: 100vw;
    overflow: scroll;
`;
export const FormWrapper = styled.form`
    width: 93vw;
    max-width: 1200px;
    margin: auto;
`;
export const FormRowWrapper = styled.div`
    display: flex;
    justify-content: space-evenly;
`;
export const FormColumnWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 38%;
`;
export const TopContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: 30px;
`;
export const LinkWrapper = styled(Link)`
    text-decoration: underline;
    font-size: 10px;
    color: #00abb6;
    margin-left: 20px;
`;
export const FieldsetWrapper = styled.div`
    padding: 10px;
`;
export const FieldsetTitleWrapper = styled.label`
    font: 16px Open Sans, Helvetica, sans-serif;
    color: grey;
    margin-top: 0px;
`;
export const FormSectionWrapper = styled.div`
    margin-top: 15px;
    margin-bottom: 50px;
`;
export const AddButtonWrapper = styled.button`
    font: 30px Open Sans, Helvetica, sans-serif;
    border-radius: 10px;
    margin-top: 10px;
    padding: 5px 15px 5px 15px;
    border: 1px solid grey;
`;
export const RemoveButton = styled.button`
    background: red;
    color: white;
    border-radius: 15px;
    height: 20px;
    font-size: 10px;
    margin-left: 10px;
`;
export const FieldsetHeaderWrapper = styled.div`
    display: flex;
`;
class CompanyInterfaceForm extends Component {
    // These functions are set to handle the different data type changes
    // At this point some of the default have the same functionality. However, they are separated
    // so that they can be overriden for special use cases if needed
    handleChange = (event, parentField, parentArrayIndex) => {
        let { type } = event.target;
        parentField ? (type = 'object') : null;
        switch (type) {
            case 'file':
                this.handleFileChange(event);
                break;
            case 'checkbox':
                this.handleCheckboxChange(event);
                break;
            case 'text':
                this.handleTextChange(event);
                break;
            case 'textarea':
                this.handleTextAreaChange(event);
                break;
            case 'object':
                this.handleFieldsetChange(event, parentField, parentArrayIndex);
                break;
            case 'number':
                this.handleNumberChange(event);
                break;
            case 'date':
                this.handleDateChange(event);
                break;
            case 'select':
                this.handleSelectChange(event);
                break;
            default:
                this.handleUnspecifiedChange(event);
                break;
        }
    };

    saveStateToLocalStorage() {
        for (let key in this.state) {
            let value = this.state[key];
            if (value !== undefined) {
                localStorage.setItem(key, JSON.stringify(value));
            }
        }
    }

    hydrateStateWithLocalStorage() {
        // for all items in state
        for (let key in this.state) {
            // if the key exists in localStorage
            if (localStorage.hasOwnProperty(key)) {
                // get the key's value from localStorage
                let value = localStorage.getItem(key);
                // get rid of empty dictionaries
                value =
                    Object.keys(value).length === 0 &&
                    value.constructor === Object
                        ? null
                        : value;
                // parse the localStorage string and setState
                try {
                    value = JSON.parse(value);
                    if (value !== undefined && value !== null) {
                        this.setState({ [key]: value });
                    }
                    localStorage.removeItem(key);
                } catch (e) {
                    // handle strings
                    if (value !== undefined && value !== null) {
                        this.setState({ [key]: value });
                    }
                    localStorage.removeItem(key);
                }
            }
        }
    }

    handleUnspecifiedChange = event => {
        let { name, value } = event.target;
        this.setState({ [name]: value });
    };

    handleDateChange = event => {
        let { name, value } = event.target;
        this.setState({ [name]: value });
    };

    handleFieldsetChange = (event, parentField, parentArrayIndex) => {
        let { name, value } = event.target;
        const isValidIndex = parentArrayIndex =>
            typeof parentArrayIndex === 'number';
        if (isValidIndex(parentArrayIndex)) {
            const { [parentField]: parentFieldArray } = this.state;
            let parentFieldItem = { ...parentFieldArray[parentArrayIndex] };
            parentFieldItem[name] = value;
            const updatedParentFieldArray = this.updateParentArray(
                parentFieldArray,
                parentFieldItem,
                parentArrayIndex,
            );
            this.setState({ [parentField]: updatedParentFieldArray });
        }
    };

    updateParentArray = (
        parentFieldArray,
        parentFieldItem,
        parentArrayIndex,
    ) => {
        let updatedParentFieldArray = parentFieldArray
            .slice(0, parentArrayIndex)
            .concat(
                [parentFieldItem],
                parentFieldArray.slice(parentArrayIndex + 1),
            );
        return updatedParentFieldArray;
    };

    handleFieldsetAdd = (event, name) => {
        const { state } = this;
        const { [name]: formValue } = this.state;
        let concatItem;
        formValue ? (concatItem = formValue) : (concatItem = []);
        const updatedFormValue = concatItem.concat(
            this.setFieldsetDefaultValues(name),
        );
        const updatedState = { ...state, [name]: updatedFormValue };
        this.setState(updatedState);
    };

    handleFieldsetRemoval = (event, name, index) => {
        const { state } = this;
        const { [name]: formValue } = this.state;
        const updatedFormValue = [
            ...formValue.slice(0, index),
            ...formValue.slice(index + 1),
        ];
        const updatedState = { ...state, [name]: updatedFormValue };
        this.setState(updatedState);
    };

    setFieldsetDefaultValues = name => {
        return [{}];
    };

    handleFileChange = event => {
        let { name, files } = event.target;
        this.setState({ [name]: files[0] });
    };

    handleNumberChange = event => {
        let { name, value } = event.target;
        this.setState({ [name]: value });
    };

    handleSelectChange = event => {
        let { name, value } = event.target;
        this.setState({ [name]: value });
    };
    handleCheckboxChange = event => {
        let { name, checked } = event.target;
        this.setState({ [name]: checked });
    };

    handleTextChange = event => {
        let { name, value } = event.target;
        this.setState({ [name]: value });
    };

    handleTextAreaChange = event => {
        let { name, value } = event.target;
        this.setState({ [name]: value });
    };

    handleTaxStatusChange = event => {
        const { name, value } = event.target;
        const isTaxExempt = value => (value === 'true' ? true : false);
        this.setState({ [name]: isTaxExempt(value) });
    };

    phoneInputMask = value => {
        let cleanedValue = ('' + value).replace(/\D/g, '');
        let regexGroupMatches = cleanedValue.match(
            /(^\d{0,1})(\d{0,3})(\d{0,3})(\d{0,4})/,
        );
        let maskedValue =
            `${regexGroupMatches[1] ? `+${regexGroupMatches[1]}` : ''}` +
            `${regexGroupMatches[2] ? `(${regexGroupMatches[2]}` : ''}` +
            `${regexGroupMatches[3] ? `)${regexGroupMatches[3]}` : ''}` +
            `${regexGroupMatches[4] ? `-${regexGroupMatches[4]}` : ''}`;
        return maskedValue;
    };

    validateInput = ({ type, value }) => {
        let errorMessage = null;
        let isValid;
        switch (type) {
            case 'name':
                isValid = /^[a-zA-Z._-\s{1}\u00C6\u00D0\u018E\u018F\u0190\u0194\u0132\u014A\u0152\u1E9E\u00DE\u01F7\u021C\u00E6\u00F0\u01DD\u0259\u025B\u0263\u0133\u014B\u0153\u0138\u017F\u00DF\u00FE\u01BF\u021D\u0104\u0181\u00C7\u0110\u018A\u0118\u0126\u012E\u0198\u0141\u00D8\u01A0\u015E\u0218\u0162\u021A\u0166\u0172\u01AFY\u0328\u01B3\u0105\u0253\u00E7\u0111\u0257\u0119\u0127\u012F\u0199\u0142\u00F8\u01A1\u015F\u0219\u0163\u021B\u0167\u0173\u01B0y\u0328\u01B4\u00C1\u00C0\u00C2\u00C4\u01CD\u0102\u0100\u00C3\u00C5\u01FA\u0104\u00C6\u01FC\u01E2\u0181\u0106\u010A\u0108\u010C\u00C7\u010E\u1E0C\u0110\u018A\u00D0\u00C9\u00C8\u0116\u00CA\u00CB\u011A\u0114\u0112\u0118\u1EB8\u018E\u018F\u0190\u0120\u011C\u01E6\u011E\u0122\u0194\u00E1\u00E0\u00E2\u00E4\u01CE\u0103\u0101\u00E3\u00E5\u01FB\u0105\u00E6\u01FD\u01E3\u0253\u0107\u010B\u0109\u010D\u00E7\u010F\u1E0D\u0111\u0257\u00F0\u00E9\u00E8\u0117\u00EA\u00EB\u011B\u0115\u0113\u0119\u1EB9\u01DD\u0259\u025B\u0121\u011D\u01E7\u011F\u0123\u0263\u0124\u1E24\u0126I\u00CD\u00CC\u0130\u00CE\u00CF\u01CF\u012C\u012A\u0128\u012E\u1ECA\u0132\u0134\u0136\u0198\u0139\u013B\u0141\u013D\u013F\u02BCN\u0143N\u0308\u0147\u00D1\u0145\u014A\u00D3\u00D2\u00D4\u00D6\u01D1\u014E\u014C\u00D5\u0150\u1ECC\u00D8\u01FE\u01A0\u0152\u0125\u1E25\u0127\u0131\u00ED\u00ECi\u00EE\u00EF\u01D0\u012D\u012B\u0129\u012F\u1ECB\u0133\u0135\u0137\u0199\u0138\u013A\u013C\u0142\u013E\u0140\u0149\u0144n\u0308\u0148\u00F1\u0146\u014B\u00F3\u00F2\u00F4\u00F6\u01D2\u014F\u014D\u00F5\u0151\u1ECD\u00F8\u01FF\u01A1\u0153\u0154\u0158\u0156\u015A\u015C\u0160\u015E\u0218\u1E62\u1E9E\u0164\u0162\u1E6C\u0166\u00DE\u00DA\u00D9\u00DB\u00DC\u01D3\u016C\u016A\u0168\u0170\u016E\u0172\u1EE4\u01AF\u1E82\u1E80\u0174\u1E84\u01F7\u00DD\u1EF2\u0176\u0178\u0232\u1EF8\u01B3\u0179\u017B\u017D\u1E92\u0155\u0159\u0157\u017F\u015B\u015D\u0161\u015F\u0219\u1E63\u00DF\u0165\u0163\u1E6D\u0167\u00FE\u00FA\u00F9\u00FB\u00FC\u01D4\u016D\u016B\u0169\u0171\u016F\u0173\u1EE5\u01B0\u1E83\u1E81\u0175\u1E85\u01BF\u00FD\u1EF3\u0177\u00FF\u0233\u1EF9\u01B4\u017A\u017C\u017E\u1E93]+$/.test(
                    value,
                );
                !isValid
                    ? (errorMessage =
                          'Symbols and numbers are not valid name characters')
                    : null;
                break;
            case 'phone':
                let testValue = ('' + value).replace(/\D/g, '');
                isValid = /(^\d{1})(\d{3})(\d{3})(\d{4})/.test(testValue);
                !isValid ? (errorMessage = 'Invalid phone number') : null;
                break;
            case 'postalCode':
                isValid = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/i.test(value);
                !isValid ? (errorMessage = 'Invalid postal code') : null;
                break;
            case 'email':
                isValid = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(
                    value,
                );
                !isValid ? (errorMessage = 'Invalid email') : null;
                break;
            default:
                break;
        }
        return errorMessage;
    };

    formatUserDataForDB = () => {
        const { firstName, lastName, profilePhotoURL, email } = this.state;

        const formattedUserData = {
            basicProfile: {
                firstName,
                lastName,
                profilePhotoURL,
            },
            profilePhotoURL,
            email,
        };

        return formattedUserData;
    };

    formatProviderDataForDB = () => {
        const {
            biography,
            certifications,
            profilePhotoURL,
            coverPhotoURL,
            designation,
            email,
            phone,
            expertise,
            isTaxExempt,
            licenseNumber,
            firstName,
            lastName,
            providerLiabilityPolicyNumber,
            providerLiabilityPolicyHolder,
            taxNumber,
            isProvider, //TODO vimeoId vimeoThumbnailURL
        } = this.state;

        const formattedEmployeeData = isProvider
            ? {
                  biography,
                  certifications,
                  profilePhotoURL,
                  phone,
                  coverPhotoURL,
                  designation,
                  email,
                  expertise,
                  isTaxExempt: isTaxExempt || false,
                  licenseNumber,
                  providerLiabilityPolicyNumber,
                  providerLiabilityPolicyHolder,
                  name: {
                      first: firstName,
                      last: lastName,
                  },
                  taxNumber: taxNumber || null,
              }
            : {
                  name: {
                      first: firstName,
                      last: lastName,
                  },
                  phone,
                  email,
                  profilePhotoURL,
              };
        return formattedEmployeeData;
    };

    getItemType = formattedData => {
        let itemType;
        const { roles } = formattedData;
        roles
            ? roles.accountAdmin
                ? (itemType = 'accountAdmins')
                : roles.staffAdmin
                ? (itemType = 'staffAdmins')
                : (itemType = 'providers')
            : (itemType = 'services');
        return itemType;
    };

    getPermissionRolesChanges = selectedPermissionRoles => {
        const { employee } = this.props;
        const { accountAdmin, staffAdmin, provider } = selectedPermissionRoles;
        const { roles } = employee;

        const accountAdminRoleChange =
            roles && roles.accountAdmin !== accountAdmin;
        const staffAdminRoleChange = roles && roles.staffAdmin !== staffAdmin;
        const providerRoleChange = roles && roles.provider !== provider;

        return employee && employee.roles
            ? {
                  accountAdmin: accountAdminRoleChange,
                  staffAdmin: staffAdminRoleChange,
                  provider: providerRoleChange,
              }
            : null;
    };

    // GENERAL USER FUNCTIONS

    getPersonalFields = () => {
        const {
            profilePhotoURL,
            firstName,
            lastName,
            email,
            phone,
            formValidationErrors,
        } = this.state;

        const { employee } = this.props;
        const doesEmployeeExist = employee => (employee ? true : false);

        return (
            <FormSectionWrapper>
                <FormImageInput
                    label=""
                    subTitle="Upload a profile image for this employee"
                    name="profilePhotoURL"
                    onChange={this.handleChange}
                    value={profilePhotoURL}
                    imageStyle={{
                        borderRadius: '50%',
                    }}
                    containerStyle={{
                        marginBottom: '50px',
                    }}
                    required={profilePhotoURL ? false : true}
                />
                <FormTextField
                    label="Email"
                    name="email"
                    onChange={this.handleChange}
                    value={email}
                    mainIconType="envelope"
                    secondaryIconType={
                        doesEmployeeExist(employee) ? null : 'pencil-alt'
                    }
                    required={true}
                    onfocusout={event =>
                        this.checkValidation({
                            event,
                            type: 'email',
                        })
                    }
                    errorMessage={
                        formValidationErrors
                            ? formValidationErrors['email']
                            : null
                    }
                    disabled={doesEmployeeExist(employee)}
                />
                <FormTextField
                    label="First name"
                    name="firstName"
                    onChange={this.handleChange}
                    value={firstName}
                    mainIconType="user"
                    secondaryIconType="pencil-alt"
                    required={true}
                    onfocusout={event =>
                        this.checkValidation({
                            event,
                            type: 'name',
                        })
                    }
                    errorMessage={
                        formValidationErrors
                            ? formValidationErrors['firstName']
                            : null
                    }
                />
                <FormTextField
                    label="Last name"
                    name="lastName"
                    onChange={this.handleChange}
                    value={lastName}
                    mainIconType="user"
                    secondaryIconType="pencil-alt"
                    required={true}
                    onfocusout={event =>
                        this.checkValidation({
                            event,
                            type: 'name',
                        })
                    }
                    errorMessage={
                        formValidationErrors
                            ? formValidationErrors['lastName']
                            : null
                    }
                />

                <FormTextField
                    label="Phone number"
                    name="phone"
                    onChange={this.handleChange}
                    value={this.phoneInputMask(phone)}
                    mainIconType="phone"
                    secondaryIconType="pencil-alt"
                    required={true}
                    onfocusout={event =>
                        this.checkValidation({
                            event,
                            type: 'phone',
                        })
                    }
                    errorMessage={
                        formValidationErrors
                            ? formValidationErrors['phone']
                            : null
                    }
                />
            </FormSectionWrapper>
        );
    };

    // PERMISSION FUNCTIONS

    getPermissionFields = () => {
        const { isAccountAdmin, isStaffAdmin, isProvider } = this.state;
        const { roles } = this.props.userData;
        const isRoleSelected = isAccountAdmin || isStaffAdmin || isProvider;
        return (
            <FormSectionWrapper
                style={{
                    marginTop: '50px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignSelf: 'flex-end',
                    alignItems: 'flex-start',
                }}
            >
                <H2 style={{ marginBottom: 10 }}>This employee can</H2>
                {roles.accountAdmin && (
                    <FormCheckboxField
                        label="manage the company account"
                        name="isAccountAdmin"
                        onChange={this.handleChange}
                        value={isAccountAdmin}
                        containerProps={{
                            border: 'none',
                            background: constants.color.grey5,
                            justifyContent: 'flex-end',
                        }}
                        // labelProps = {{
                        //     width: '150px'
                        // }}
                        required={!isRoleSelected}
                    />
                )}

                {roles.accountAdmin && (
                    <FormCheckboxField
                        label="manage staff and services"
                        name="isStaffAdmin"
                        onChange={this.handleChange}
                        value={isStaffAdmin}
                        containerProps={{
                            border: 'none',
                            background: constants.color.grey5,
                            justifyContent: 'flex-end',
                        }}
                        // labelProps = {{
                        //     width: '150px'
                        // }}
                        required={!isRoleSelected}
                    />
                )}

                <FormCheckboxField
                    label="provide services"
                    name="isProvider"
                    onChange={this.handleChange}
                    value={isProvider}
                    containerProps={{
                        border: 'none',
                        background: constants.color.grey5,
                        justifyContent: 'flex-end',
                    }}
                    // labelProps = {{
                    //     width: '150px'
                    // }}
                    required={!isRoleSelected}
                />
            </FormSectionWrapper>
        );
    };

    // PROVIDER SPECIFIC FUNCTIONS

    getProviderInformationFields = () => {
        const { biography, expertise, designation } = this.state;

        return (
            <FormSectionWrapper>
                <FormSectionTitle
                    label={'Provider information'}
                    mainIconType="certificate"
                />
                <FormTextField
                    description="Area of Focus"
                    label='ie. "Knee Rehabilitation"'
                    name="expertise"
                    onChange={this.handleChange}
                    value={expertise}
                    mainIconType="user"
                    secondaryIconType="pencil-alt"
                    required={true}
                />
                <FormTextField
                    description="Designation"
                    label='ie. "Physiotherapist"'
                    name="designation"
                    onChange={this.handleChange}
                    value={designation}
                    mainIconType="user"
                    secondaryIconType="pencil-alt"
                    required={true}
                />
                <FormSectionTitle
                    label={'Public Bio'}
                    mainIconType={'file-alt'}
                />
                <FormTextArea
                    label="Write a description..."
                    name={'biography'}
                    onChange={this.handleChange}
                    value={biography}
                    required={true}
                />
            </FormSectionWrapper>
        );
    };

    getProviderLegalFields = () => {
        const {
            providerLiabilityPolicyHolder,
            providerLiabilityPolicyNumber,
            isTaxExempt,
            taxNumber,
        } = this.state;

        return (
            <FormSectionWrapper>
                <FormSectionTitle
                    label={'Legal information'}
                    mainIconType="certificate"
                />
                <FormTextField
                    label="Liability policy holder"
                    name="providerLiabilityPolicyHolder"
                    onChange={this.handleChange}
                    value={providerLiabilityPolicyHolder}
                    mainIconType="check"
                    secondaryIconType="pencil-alt"
                    required={true}
                />
                <FormTextField
                    label="Liability policy number"
                    name="providerLiabilityPolicyNumber"
                    onChange={this.handleChange}
                    value={providerLiabilityPolicyNumber}
                    mainIconType="check"
                    secondaryIconType="pencil-alt"
                    required={true}
                />
                <FormSelectField
                    label={'Tax Exempt Status'}
                    name={'isTaxExempt'}
                    value={isTaxExempt || false}
                    options={constants.option.taxExemptStatus}
                    onChange={this.handleTaxStatusChange}
                    displayKey={'label'}
                    valueKey={'value'}
                    required={true}
                />
                {!isTaxExempt && (
                    <FormTextField
                        label="GST/HST Number"
                        name="taxNumber"
                        onChange={this.handleChange}
                        value={taxNumber}
                        mainIconType="check"
                        secondaryIconType="pencil-alt"
                        required={true}
                    />
                )}
            </FormSectionWrapper>
        );
    };

    getProviderProfessionalFields = () => {
        const { licenseNumber, certifications } = this.state;

        return (
            <FormSectionWrapper>
                <FormSectionTitle
                    label={'Professional information'}
                    mainIconType="certificate"
                />
                <FormTextField
                    label="License number"
                    name="licenseNumber"
                    onChange={this.handleChange}
                    value={licenseNumber}
                    secondaryIconType="pencil-alt"
                    required={true}
                />
                <FormSectionTitle
                    label="Certifications"
                    mainIconType="certificate"
                />
                {certifications && certifications.map(this.getCertifications)}
                <AddButtonWrapper
                    onClick={e => this.handleFieldsetAdd(e, 'certifications')}
                    type="button"
                >
                    +
                </AddButtonWrapper>
            </FormSectionWrapper>
        );
    };

    getCertifications = (certification, index) => {
        const { title, suffix, provinces } = certification;
        return (
            <FieldsetWrapper>
                <FieldsetHeaderWrapper>
                    <FieldsetTitleWrapper>
                        Certification #{index + 1}
                    </FieldsetTitleWrapper>
                    <RemoveButton
                        onClick={e =>
                            this.handleFieldsetRemoval(
                                event,
                                'certifications',
                                index,
                            )
                        }
                        type="button"
                    >
                        Remove
                    </RemoveButton>
                </FieldsetHeaderWrapper>
                <FormTextField
                    label="Title"
                    name="title"
                    onChange={e =>
                        this.handleChange(e, 'certifications', index)
                    }
                    value={title}
                    secondaryIconType="pencil-alt"
                    index={index}
                    required={true}
                />
                <FormTextField
                    label="Suffix"
                    name="suffix"
                    onChange={e =>
                        this.handleChange(e, 'certifications', index)
                    }
                    value={suffix}
                    secondaryIconType="pencil-alt"
                    required={true}
                />
                <FormSelectField
                    label={'Valid in'}
                    name={'provinces'}
                    value={provinces || []}
                    options={constants.option.provinces}
                    multiple={true}
                    onChange={e =>
                        this.handleChange(e, 'certifications', index)
                    }
                    displayKey={'label'}
                    valueKey={'value'}
                    required={true}
                />
            </FieldsetWrapper>
        );
    };

    getCoverPhotoField = ({ subTitle }) => {
        const { coverPhotoURL } = this.state;
        return (
            <FormSectionWrapper>
                <FormSectionTitle
                    label={'Background Image'}
                    mainIconType="image"
                    subTitle={subTitle}
                />
                <FormImageInput
                    label=""
                    name="coverPhotoURL"
                    onChange={this.handleChange}
                    value={coverPhotoURL}
                    required={coverPhotoURL ? false : true}
                />
            </FormSectionWrapper>
        );
    };

    // COMPANY FUNCTIONS

    getCompanyDescriptionFields = () => {
        const { companyLogo, name, description } = this.state;
        const isCompanyLogoRequired = logoData => (logoData ? false : true);
        return (
            <FormSectionWrapper>
                <FormSectionTitle
                    label={'Company description'}
                    mainIconType={'file-alt'}
                />
                <FormImageInput
                    label="Logo"
                    name="companyLogo"
                    onChange={this.handleChange}
                    value={companyLogo}
                    imageStyle={{
                        borderRadius: '50%',
                    }}
                    containerStyle={{
                        marginBottom: '50px',
                    }}
                    required={isCompanyLogoRequired(companyLogo)}
                />
                <FormTextField
                    label="Company name"
                    name="name"
                    onChange={this.handleChange}
                    value={name}
                    mainIconType="user"
                    secondaryIconType="pencil-alt"
                    required={true}
                />
                <FormTextArea
                    label="Write a description..."
                    name={'description'}
                    onChange={this.handleChange}
                    value={description}
                    required={true}
                />
            </FormSectionWrapper>
        );
    };

    getCompanyAddressFields = () => {
        const {
            street,
            city,
            province,
            postalCode,
            country,
            formValidationErrors,
        } = this.state;

        return (
            <FormSectionWrapper>
                <FormSectionTitle
                    label={'Address information'}
                    mainIconType={'folder'}
                />
                <FormTextField
                    label="Street"
                    name="street"
                    onChange={this.handleChange}
                    value={street}
                    mainIconType="building"
                    secondaryIconType="pencil-alt"
                    required={true}
                />
                <FormTextField
                    label="City"
                    name="city"
                    onChange={this.handleChange}
                    value={city}
                    mainIconType="building"
                    secondaryIconType="pencil-alt"
                    required={true}
                />
                <FormTextField
                    label="Province"
                    name="province"
                    onChange={this.handleChange}
                    value={province}
                    mainIconType="map-marker-alt"
                    secondaryIconType="pencil-alt"
                    required={true}
                />
                <FormTextField
                    label="Postal code"
                    name="postalCode"
                    onChange={this.handleChange}
                    value={postalCode}
                    mainIconType="map-marker-alt"
                    secondaryIconType="pencil-alt"
                    required={true}
                    onfocusout={event =>
                        this.checkValidation({
                            event,
                            type: 'postalCode',
                        })
                    }
                    errorMessage={
                        formValidationErrors
                            ? formValidationErrors['postalCode']
                            : null
                    }
                />
                <FormTextField
                    label="Country"
                    name="country"
                    onChange={this.handleChange}
                    value={country}
                    mainIconType="map-marker-alt"
                    secondaryIconType="pencil-alt"
                    required={true}
                    onfocusout={event =>
                        this.checkValidation({
                            event,
                            type: 'name',
                        })
                    }
                    errorMessage={
                        formValidationErrors
                            ? formValidationErrors['country']
                            : null
                    }
                />
            </FormSectionWrapper>
        );
    };

    // SERVICE FUNCTIONS

    getServiceGeneralInformationFields = () => {
        const { name, description, provider } = this.state;
        const { service } = this.props;
        const doesServiceExist = service =>
            service ? Object.keys(service).length > 0 : false;
        return (
            <FormSectionWrapper>
                <FormSectionTitle
                    label="Service Name"
                    mainIconType="file-alt"
                />
                <FormTextField
                    label="Name"
                    name="name"
                    onChange={this.handleChange}
                    value={name}
                    mainIconType="envelope"
                    secondaryIconType="pencil-alt"
                    required={true}
                />
                {!doesServiceExist(service) && (
                    <React.Fragment>
                        <FormSectionTitle
                            label="Service Provider"
                            mainIconType="user"
                            style={{ marginBottom: 20 }}
                        />
                        <FormSelectField
                            label={'Select a service provider'}
                            name={'provider'}
                            value={provider}
                            options={this.props.providers}
                            onChange={this.handleSelectChange}
                            displayKey={'fullName'}
                            valueKey={'uid'}
                            required={true}
                        />
                    </React.Fragment>
                )}
                <FormSectionTitle label="Description" mainIconType="file-alt" />
                <FormTextArea
                    label="Write a description..."
                    name={'description'}
                    onChange={this.handleChange}
                    value={description}
                    required={true}
                />
            </FormSectionWrapper>
        );
    };

    getServiceDetailsFields = () => {
        const { consultDuration, serviceDuration, price, modules } = this.state;
        return (
            <FormSectionWrapper>
                <FormSectionTitle
                    label="Modules"
                    mainIconType="cube"
                    subTitle="Select the service module(s) that you would like to use for offering this service."
                />
                {modules && modules.map(this.getModules)}
                <Button
                    onClick={e => this.handleFieldsetAdd(e, 'modules')}
                    type="button"
                >
                    Add a Module
                </Button>
                <FormSectionTitle
                    label="Service Details"
                    mainIconType="file-alt"
                />

                <FormTextField
                    description="How long will this video consultation be?"
                    label="Video consultation duration (in 15min increments)"
                    name="consultDuration"
                    onChange={this.handleChange}
                    value={consultDuration}
                    mainIconType="user-clock"
                    secondaryIconType="pencil-alt"
                    required={true}
                    inputProps={{
                        type: 'number',
                        step: '15',
                        min: '15',
                    }}
                />
                <FormTextField
                    description="How many days will this service be active for?"
                    label="Service duration (in days)"
                    name="serviceDuration"
                    onChange={this.handleChange}
                    value={serviceDuration}
                    mainIconType="user-clock"
                    secondaryIconType="pencil-alt"
                    required={true}
                    inputProps={{
                        type: 'number',
                        min: '1',
                    }}
                />
                <FormTextField
                    description="How much will this service cost?"
                    label="Price"
                    name="price"
                    onChange={this.handleChange}
                    value={price}
                    mainIconType="dollar-sign"
                    secondaryIconType="pencil-alt"
                    required={true}
                    inputType="number"
                    inputProps={{
                        type: 'number',
                        min: '0',
                    }}
                />
            </FormSectionWrapper>
        );
    };

    getModules = (moduleItem, index) => {
        const { type, description } = moduleItem;
        const { modules } = this.props;
        return (
            <FieldsetWrapper>
                <FieldsetHeaderWrapper>
                    <FieldsetTitleWrapper>
                        Module #{index + 1}
                    </FieldsetTitleWrapper>
                    <RemoveButton
                        onClick={e =>
                            this.handleFieldsetRemoval(event, 'modules', index)
                        }
                        type="button"
                    >
                        Remove
                    </RemoveButton>
                </FieldsetHeaderWrapper>
                <FormSelectField
                    label={'Type'}
                    name={'type'}
                    value={type}
                    options={modules || []}
                    onChange={e => this.handleChange(e, 'modules', index)}
                    displayKey={'description'}
                    valueKey={'_id'}
                    required={true}
                />
                <FormTextArea
                    label="Write a description..."
                    name={'description'}
                    onChange={e => this.handleChange(e, 'modules', index)}
                    value={description}
                    required={true}
                />
            </FieldsetWrapper>
        );
    };

    getLoader = () => {
        let loader;
        this.state.isLoading ? (loader = <LoaderWrapper />) : (loader = null);
        return loader;
    };

    getTopContainerActions = () => {
        return <div>No actions</div>;
    };

    getFormFields = () => {
        return <div>No form fields</div>;
    };

    render() {
        return <div />;
    }
}

export default CompanyInterfaceForm;



// WEBPACK FOOTER //
// ./src/js/containers/CompanyContainer/CompanyInterfaceForm.jsx